import { createSelector } from '@ngrx/store';

import { getCart } from '@shared/state/cart/selectors';
import { getCollectionType } from '@shared/state/collectionType/selectors';

export const getSelectedOrderTypeId = createSelector(getCart, getCollectionType, (cart, collectionType) => collectionType.orderTypeId || cart.orderTypeId);
